import type { IAuthentication } from '~/types/authentication'

import config from '~/config'
import { request } from '~/utils/request'

export const refreshToken = async (storedRefreshToken: string): Promise<IAuthentication> => {
  return request({
    url: `${config.AUTHORIZATION_API}/oauth/token?grant_type=refresh_token&refresh_token=${storedRefreshToken}`,
  })
}
